
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Use `npm run licenses` to generate the json file
var $cd7869d0c91ec793$exports = {};
$cd7869d0c91ec793$exports = JSON.parse("[]");


// interaction:
const $f951b0d83789d0a7$var$dialogElement = document.getElementById("about-dialog");
const $f951b0d83789d0a7$var$aboutButton = document.getElementById("about-button");
document.body.addEventListener("click", function(event) {
    if ($f951b0d83789d0a7$var$dialogElement == event.target) return;
    if (event.target && $f951b0d83789d0a7$var$dialogElement.contains(event.target)) return;
    if (event.target == $f951b0d83789d0a7$var$aboutButton) return;
    $f951b0d83789d0a7$var$dialogElement.close();
});
$f951b0d83789d0a7$var$aboutButton.onclick = function() {
    $f951b0d83789d0a7$var$dialogElement.show();
};
// content:
const $f951b0d83789d0a7$var$listElement = document.createElement("div");
$f951b0d83789d0a7$var$listElement.className = "about-section-body";
for (const project of (0, (/*@__PURE__*/$parcel$interopDefault($cd7869d0c91ec793$exports)))){
    const listItem = document.createElement("div");
    listItem.className = "about-listing";
    // add name
    const nameElement = document.createElement("div");
    nameElement.innerText = project.name;
    listItem.appendChild(nameElement);
    // add links
    const linksElement = document.createElement("div");
    linksElement.className = "links";
    if (project.homepage) {
        const homepageLinkElement = document.createElement("a");
        homepageLinkElement.innerText = "Homepage";
        homepageLinkElement.href = project.homepage;
        homepageLinkElement.target = "_blank";
        linksElement.appendChild(homepageLinkElement);
    }
    const licenseText = project.licenses.map((license)=>license.text).join("\n\n" + "-".repeat(80) + "\n\n");
    const licenseLinkElement = document.createElement("a");
    licenseLinkElement.innerText = "License";
    licenseLinkElement.href = "javascript:void";
    licenseLinkElement.onclick = function() {
        const w = window.open("about:blank");
        w.document.body.innerText = licenseText;
    };
    linksElement.appendChild(licenseLinkElement);
    listItem.appendChild(linksElement);
    // add to list
    $f951b0d83789d0a7$var$listElement.appendChild(listItem);
}
$f951b0d83789d0a7$var$dialogElement.appendChild($f951b0d83789d0a7$var$listElement);


//# sourceMappingURL=index.90e8d413.js.map
